import ROUTENAMES from './route-names';

let TITLES = {};

TITLES[ROUTENAMES.DASHBOARD_PAGE_ROUTE] = 'pages.news';
TITLES[ROUTENAMES.CATALOG_PAGE_ROUTE] = 'pages.catalog';
TITLES[ROUTENAMES.CATALOG_PRODUCTS_PAGE_ROUTE] = 'pages.products';
TITLES[ROUTENAMES.CATALOG_SYSTEMS_PAGE_ROUTE] = 'pages.systems';
TITLES[ROUTENAMES.QR_SCAN_PAGE_ROUTE] = 'pages.qrscanner';
TITLES[ROUTENAMES.PRODUCT_VIEW_PAGE_ROUTE] = 'pages.details';
TITLES[ROUTENAMES.SYSTEM_VIEW_PAGE_ROUTE] = 'pages.details';
TITLES[ROUTENAMES.SYSTEM_APPLICATIONS_PAGE_ROUTE] = 'pages.system_applications';
TITLES[ROUTENAMES.CART_OVERVIEW_PAGE_ROUTE] = 'pages.cart';
TITLES[ROUTENAMES.MY_ACCOUNT_PAGE_ROUTE] = 'pages.myaccount';
TITLES[ROUTENAMES.CHECKOUT_TYPE_PAGE_ROUTE] = 'pages.checkout_type';
TITLES[ROUTENAMES.CHECKOUT_DETAILS_PAGE_ROUTE] = 'pages.checkout_details';
TITLES[ROUTENAMES.CHECKOUT_SUMMARY_PAGE_ROUTE] = 'pages.checkout_summary';
TITLES[ROUTENAMES.ALL_CART_ORDERSREQUESTS_PAGE_ROUTE] = 'pages.overview';
TITLES[ROUTENAMES.ORDER_DETAIL_PAGE_ROUTE] = 'pages.details';
TITLES[ROUTENAMES.REQUEST_DETAIL_PAGE_ROUTE] = 'pages.details';
TITLES[ROUTENAMES.QCVMIXER_PAGE_ROUTE] = 'pages.qcvmixer';
TITLES[ROUTENAMES.ELASTICMIXER_PAGE_ROUTE] = 'pages.elasticmixer';

export default TITLES;
